// Presentation-only catalog for the /pricing page and any other place that
// needs to show plan names/prices/features (AccountPlanSection, future
// upgrade prompts). This is NOT an authorization source — real entitlement
// always flows through the backend access service
// (who-would-win-server/src/main/services/accessService.js). A tier here
// with `comingSoon: true` has no purchase path yet; nothing in this file
// should ever be read to decide what a user is allowed to do.
// Standard/Premium prices and feature lists below are the intended final
// plan shape (not yet finalized) — comingSoon stays true since there's no
// checkout until Phase 6 lands, but the copy itself is meant to be edited
// here directly as pricing/features get locked in, not treated as launched.
export const PLAN_DEFINITIONS = {
  free: {
    id: "free",
    name: "Free",
    description: "Battle anyone and anything. See who wins.",
    price: 0,
    currency: "USD",
    interval: null,
    comingSoon: false,
    ctaLabel: "Create Free Account",
    footnote: "Free forever • Ad-supported",
    // No image-generation claim here on purpose — Free's target model is a
    // public preview (or a character-color gradient placeholder) of a
    // battle's scene image, not on-demand generation. See media-visibility
    // spec (Phase 9) for the preview/gradient resolution rules this refers to.
    features: [
      "AI-powered battle results",
      "Full battle analysis & narration",
      "Trending battles & battle sharing",
      "Save up to 50 battles with a free account",
      "Public battle image previews",
    ],
  },
  standard: {
    id: "standard",
    name: "Standard",
    description: "Bring your battles to life with AI-generated artwork.",
    price: 4.99,
    currency: "USD",
    interval: "month",
    comingSoon: true,
    ctaLabel: "Upgrade to Standard",
    features: [
      "Everything in Free",
      "No ads",
      "AI-generated battle scene images",
      "Image regeneration",
      "Higher usage limits",
    ],
  },
  premium: {
    id: "premium",
    name: "Premium",
    description: "The full arena experience.",
    price: 9.99,
    currency: "USD",
    interval: "month",
    comingSoon: true,
    ctaLabel: "Upgrade to Premium",
    features: [
      "Everything in Standard",
      "Premium-quality AI battle images",
      "Highest usage limits",
      { text: "Battle video generation", comingSoon: true },
      "Early access to select new features",
    ],
  },
};

export const PLAN_ORDER = ["free", "standard", "premium"];

export function getPlanDefinition(tier) {
  return PLAN_DEFINITIONS[tier] ?? PLAN_DEFINITIONS.free;
}

export function getPublicPlans() {
  return PLAN_ORDER.map(getPlanDefinition);
}
